let _local = 0;
/**
 * Находит label[for="_prev"] / label[for="_next"] и привязывает их к соседним элементам:
 * - добавляет __i на label,
 * - если у соседнего элемента нет id — проставляет,
 * - заменяет for на найденный id.
 */
function wireNeighborLabels(root, opt = {}) {
    const makeId = opt.nextId ?? (() => `_id${++_local}`);
    const labels = root.querySelectorAll(`label[for="_prev"], label[for="_next"]`);
    labels.forEach(lab => {
        // 2026-06-03: __i означает, что label прошёл wiring-обработку; for меняем только если сосед найден.
        lab.classList.add('__i');
        const dir = lab.getAttribute('for');
        const neighbor = dir === '_prev' ? lab.previousElementSibling
            : lab.nextElementSibling;
        if (!neighbor)
            return;
        let id = neighbor.getAttribute('id');
        if (!id) {
            id = makeId();
            neighbor.setAttribute('id', id);
        }
        lab.setAttribute('for', id);
    });
}

export { wireNeighborLabels };
